import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { fetchALLGigsApi } from "../../API/API";

function* fetchAllGigsSaga(action) {
  try {
    const { GigName } = action.payload;
    const response = yield call(() => fetchALLGigsApi(GigName));
    yield put({ type: types.FETCH_GIGSALL_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_GIGSALL_FAILURE, error });
  }
}

export function* watchFetchAllGigsSaga() {
  yield takeEvery(types.FETCH_GIGSALL_REQUESTED, fetchAllGigsSaga);
}
